import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.RequestSearchPopup.QBOSearchFields', {
    qbooksRequestorFieldTitle: 'Requester',
    qbooksRequestorPlaceholder: 'Select requester',
    qbooksPoNumberFieldTitle: 'Number',
    qbooksPoNumberPlaceholder: 'Enter number',
    qbooksVendorFieldTitle: 'Vendor',
    qbooksVendorPlaceholder: 'Select vendor',
    qbooksProductFieldTitle: 'Product',
    qbooksProductPlaceholder: 'Select product',
    qbooksPayeeVendorFieldTitle: 'Payee (Vendor)',
    qbooksPayeeVendorPlaceholder: 'Select payee vendor',
    qbooksPayeeCustomerFieldTitle: 'Payee (Customer)',
    qbooksPayeeCustomerPlaceholder: 'Select payee customer',
    qbooksPayeeEmployeeFieldTitle: 'Payee (Employee)',
    qbooksPayeeEmployeePlaceholder: 'Select payee employee',
    qbooksPaymentAccountFieldTitle: 'Payment Account',
    qbooksPaymentAccountPlaceholder: 'Select payment account',
    qbooksAccountFieldTitle: 'Account',
    qbooksAccountPlaceholder: 'Select account',
    qbooksCurrencyFieldTitle: 'Currency',
    qbooksCurrencyPlaceholder: 'Select currency',
    qbooksCustomerFieldTitle: 'Customer',
    qbooksCustomerPlaceholder: 'Select customer',
    qbooksEmployeeFieldTitle: 'Employee',
    qbooksEmployeePlaceholder: 'Select employee',
    qbooksClassFieldTitle: 'Class',
    qbooksClassPlaceholder: 'Select class',
    qbooksDepartmentFieldTitle: 'Location',
    qbooksDepartmentPlaceholder: 'Select location',
    qbooksPOStatusFieldTitle: 'PO Status',
    qbooksPOStatusPlaceholder: 'Select status',
    dateGreaterEqualsPlaceholder: 'Enter date',
    dateLessEqualsPlaceholder: 'Enter date',
    dateFieldTitle: 'Date',
    dateFromLabel: 'From',
    dateToLabel: 'To',
});
